import React, { useState, useEffect } from 'react'
import CustomCheckbox2 from '../../../../BuisnessDashboard/common/CustomCheckbox2';
import moment from "moment";
import { getAgreegatorListDistinctApi } from '../../../../maketingComponents/actioncreator';
import { saveBugetPlan } from '../../../../actioncreatormarketing';
export default function BudgetPlan({ handleSave, setLoader, setSaveHandler }) {
    const [agreegatorDataListstate, setAgreegatorDataListstate] = useState('');
    const [objectData, setObjectData] = useState({
        aggregator: "",
        startDate: "",
        endDate: "",
        totalBudget: "",
        leadsExpected: "",
        commitedLeads: "",
        commitedDisbursment: "",
        commitedDisbursmentAmount: "",
        expectedDisbursmentAmount: "",
        notify: false,
        email: "",

    })

    useEffect(()=>{
        getAgreegatorDataList()
    },[])

    const getAgreegatorDataList = () => {
        setLoader(true)
        getAgreegatorListDistinctApi((callback) => {
            setAgreegatorDataListstate(callback);
             setLoader(false)
        });
    };

    const handleChange = (e, type) => {
        const { value, checked } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: type == "notify" ? checked : value
        }))
    }

    useEffect(() => {
        setSaveHandler(() => saveRegistration);
    }, [objectData]);

    const saveRegistration = async () => {
        console.log("Saving data:", objectData);
        const obj = {
            aggregatorId:objectData?.aggregator ?? "",
            sDate:moment(objectData?.startDate).format("DD-MM-YYYY"),
            eDate:moment(objectData?.endDate).format("DD-MM-YYYY"),
            amount:objectData?.totalBudget ?? "",
            expectedLeadCount:objectData?.leadsExpected ?? "",
            committedLeads:objectData?.commitedLeads ?? "",
            commitedDisbursement:objectData?.commitedDisbursment ?? "",
            committedDisbAmt:objectData?.commitedDisbursmentAmount ?? "",
            expectedDisbAmt:objectData?.expectedDisbursmentAmount ?? "",
            notification:objectData?.notify ?? "",
            emailId:objectData?.email ?? "",
        }

        saveBugetPlan(obj, callback => {

            if (callback === 'success') {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
                removePopup()

            } else {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Please try again later !" })
                removePopup()
            }
        })
    }
    return (
        <>
            <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee', marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Aggregator</label>
                            <select className='customInput-new' type="text" value={objectData?.aggregator} onChange={(e) => handleChange(e, "aggregator")} >
                                <option value={""}>Select Option</option>
                                {agreegatorDataListstate && agreegatorDataListstate.map((data, i) => {
                                    return (
                                        <option value={data.aggregatorId}>{data?.aggregatorName}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Start Date</label>
                            <input className='customInput-new' type="date" value={objectData?.startDate} onChange={(e) => handleChange(e, "startDate")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">End Date</label>
                            <input className='customInput-new' type="date" value={objectData?.endDate} onChange={(e) => handleChange(e, "endDate")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Total Budget</label>
                            <input className='customInput-new' type="text" value={objectData?.totalBudget} onChange={(e) => handleChange(e, "totalBudget")} />
                        </div>
                    </div>

                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">No. of Leads Expected</label>
                            <input className='customInput-new' type="number" value={objectData?.leadsExpected} onChange={(e) => handleChange(e, "leadsExpected")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Commited Leads</label>
                            <input className='customInput-new' type="text" value={objectData?.commitedLeads} onChange={(e) => handleChange(e, "commitedLeads")} />

                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Commited Disbursement</label>
                            <input className='customInput-new' type="email" value={objectData?.commitedDisbursment} onChange={(e) => handleChange(e, "commitedDisbursment")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Commited Disbursement Amount</label>
                            <input className='customInput-new' type="number" value={objectData?.commitedDisbursmentAmount} onChange={(e) => handleChange(e, "commitedDisbursmentAmount")} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Expected Disbursment Amount </label>
                            <input className='customInput-new' type="text" value={objectData?.expectedDisbursmentAmount} onChange={(e) => handleChange(e, "expectedDisbursmentAmount")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box' style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '40px' }}>
                            <CustomCheckbox2
                                checked={objectData?.notify}
                                onChange={(e) => handleChange(e, "notify")}
                            />
                            <label htmlFor="" className="label-new">Notify on Budget/Lead Exceed</label>
                        </div>
                    </div>
                    {
                        objectData?.notify ?
                            <div className="col-sm-3 col-xs-12">
                                <div className='customInput-box'>
                                    <label htmlFor="" className="label-new">Email</label>
                                    <input className='customInput-new' type="email" value={objectData?.email} onChange={(e) => handleChange(e, "email")} />
                                </div>
                            </div>
                            : ""}


                </div>

            </div>
        </>
    )
}
